import { Injectable } from '@angular/core';
import { VersionDefaultParams as DefaultParams } from '@app/models/version-default-params.class';
import { Version, VersionCreate } from '@app/models/version.interface';
import { VersionsService } from '@lib/core';
import { Observable, map } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class VersionHelperService {

  constructor(
    private service: VersionsService,
  ) { }

  getAll(): Observable<Version[]> {
    let params = new DefaultParams();
    return this.service.versionsGet(params)
      .pipe(map(x => <Version[]>x));
  }
  getById(id: number): Observable<Version> {
    let params = <any>new DefaultParams();
    params.id = 'eq.' + id;
    return this.service.versionsGet(params)
      .pipe(map(x => <Version>x[0]));
  }
  create(input: VersionCreate) {
    return this.service.versionsPost({
      versions: <any>input,
      prefer: "return=representation"
    }, 'response')
    .pipe(map(response => response.body[0]))
    .pipe(map(body => {
      //console.log(body)
      return (<Version>body).id;
    }));
  }
  update(id: number, input: VersionCreate) {
    return this.service.versionsPatch({
      id: 'eq.'+id,
      versions: <any>input
    }, 'response')
    .pipe(map(response => response.ok));
  }
}
